/*
 *==================================================
 * Licensed Materials - ADIACENT
 *
 * user roles (mroService.getRoles) held in redux state
 *
 *==================================================
 */
//Standard libraries
import { takeLatest } from "redux-saga/effects";
//Redux
import * as WORKERS from "../workers/userRoles";
import { USER_ROLES_GET_REQUESTED_ACTION } from "../../actions/userRoles";

export function* watchSaga() {
  yield takeLatest(USER_ROLES_GET_REQUESTED_ACTION, WORKERS.getUserRoles);
}
